import { Card, Space, Typography } from 'antd';
import { EyebrowLabel, space } from '@viq-admin/ui';
import { displayName } from './labels';
import type { LeadDetail } from './types';

interface Props {
  opportunities: LeadDetail['opportunities'];
}

function formatUsd(n: number | null): string {
  if (n == null) return '';
  return n.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });
}

export function OpportunitiesPanel({ opportunities }: Props) {
  // Render DESC order (backend already returns DESC but sort defensively).
  const sorted = [...opportunities].sort(
    (a, b) => b.createdAt.localeCompare(a.createdAt),
  );

  return (
    <Card size="small">
      <EyebrowLabel>Opportunities</EyebrowLabel>
      {sorted.length === 0 ? (
        <Typography.Text type="secondary">No opportunity logged.</Typography.Text>
      ) : (
        <Space direction="vertical" size={8} style={{ width: '100%' }}>
          {sorted.map((o) => (
            <div
              key={o.id}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'baseline',
                gap: space.sm,
              }}
            >
              <Space direction="vertical" size={0}>
                {o.amountUsd != null && (
                  <Typography.Text strong>{formatUsd(o.amountUsd)}</Typography.Text>
                )}
                {o.stage && (
                  <Typography.Text>{displayName('stage', o.stage)}</Typography.Text>
                )}
                <Typography.Text type="secondary">
                  Source: {o.source}
                </Typography.Text>
              </Space>
              <Typography.Text type="secondary" style={{ whiteSpace: 'nowrap' }}>
                {new Date(o.createdAt).toLocaleDateString()}
              </Typography.Text>
            </div>
          ))}
        </Space>
      )}
    </Card>
  );
}
